import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {logout, onForbidden} from '../account/login';
import {getCurrentGroup} from "../account/role";
import _ from 'lodash';
import moment from 'moment';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from "../common/submitForm";

//- Actions
export const getBulkRequestsJobs = () => (dispatch, getState) => {
    let departmentId = getCurrentGroup(getState());
    if (!_.isNil(departmentId)) {
        dispatch(fetchGetBulkRequestsJobs(departmentId))
    }
};

export const fetchGetBulkRequestsSuccess = createAction('FETCH_GET_BULK_REQUESTS_JOBS_SUCCESS');
export const fetchGetBulkRequestsFailed = createAction('FETCH_GET_BULK_REQUESTS_JOBS_FAILED');
export const fetchGetBulkRequestsJobs = createAction(
    'FETCH_GET_BULK_REQUESTS_JOBS',
    (groupId) => Api.getBulkRequestsJobs(groupId),
    () => ({
        apiCall: true,
        onSuccess: fetchGetBulkRequestsSuccess,
        onFail: fetchGetBulkRequestsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onRemoveBulkConsentRequest = (id) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchRemoveBulkConsentRequest(id))
};

export const fetchRemoveBulkConsentRequestSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(getBulkRequestsJobs())
};


export const fetchRemoveBulkConsentRequest = createAction(
    'FETCH_REMOVE_BULK_CONSENT_REQUEST',
    (bulkId) => Api.removeBulkRequestJob(bulkId),
    () => ({
        apiCall: true,
        onSuccess: fetchRemoveBulkConsentRequestSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchResumeBulkConsentRequest = createAction(
    'FETCH_RESUME_BULK_CONSENT_REQUEST',
    (bulkId) => Api.resumeBulkRequestJob(bulkId),
    () => ({
        apiCall: true,
        onSuccess: fetchResumeBulkConsentRequestSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const onResumeBulkConsentRequest = (id) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchResumeBulkConsentRequest(id))
};

export const fetchResumeBulkConsentRequestSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(getBulkRequestsJobs())
};

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false,
};

//- Reducers
export default handleActions({
    FETCH_GET_BULK_REQUESTS_JOBS: (state) => {
        return {...state, fetching: true, error: null};
    },
    FETCH_GET_BULK_REQUESTS_JOBS_SUCCESS: (state, action) => {
        return {...state, fetching: false, error: null, data: action.payload}
    },
    FETCH_GET_BULK_REQUESTS_JOBS_FAILED: (state, action) => {
        return {...state, fetching: false, error: action.payload, data: null}
    }
}, initialState);

//- Selectors
export const getBulkConsentRequests = state => state.bulkConsentRequests;

export const loadingBulkConsentRequests = state => getBulkConsentRequests(state).fetching;

export const getBulkConsentRequestsData = state => getBulkConsentRequests(state).data;

export const getBulkConsentRequestsFormattedData = state => {
    return _.map(getBulkConsentRequestsData(state), jobData => ({
        id: jobData.id,
        processedPersent: Math.floor(jobData.processedEntriesCount / jobData.totalEntriesCount * 100),
        processedEntriesCount: jobData.processedEntriesCount,
        createdConsentRequestsCount: jobData.createdConsentRequestsCount,
        totalEntriesCount: jobData.totalEntriesCount,
        finished: jobData.finished,
        error: jobData.error,
        jobTitle: jobData.jobDescription.title,
        jobReference: jobData.jobDescription.internalReference,
        requesterEmail: jobData.requester.email,
        departmentName: jobData.department.name,
        departmentEmail: jobData.department.email,
        createdAt: moment(jobData.createdAt).format("MMMM Do YYYY, HH:mm"),
    }));
};



// WEBPACK FOOTER //
// ./src/reducers/consent/bulkConsentRequests.js